import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import Markdown from '../../../components/Markdown/Markdown'

const markdownMainComponent = ({ classes }) => ({
  component: Typography,
  props: {
    className: classes.typography,
    component: 'pre',
    paragraph: true,
    variant: 'body2',
  },
})

const markdownOptions = ({ classes }) => ({
  overrides: {
    code: markdownMainComponent({ classes }),
    li: markdownMainComponent({ classes }),
    ol: markdownMainComponent({ classes }),
    p: markdownMainComponent({ classes }),
    pre: markdownMainComponent({ classes }),
    ul: markdownMainComponent({ classes }),
    a: {
      component: Link,
      props: {
        target: '_blank',
      },
    },
  },
})

const styles = {
  typography: {
    whiteSpace: 'break-spaces',
  },
}
const useStyles = makeStyles(styles)

export default function PanelFieldPreValue(props) {
  const { value } = props

  const sanitizedValue = value.replace(/[\n\s]+$/g, '')

  const classes = useStyles()

  const options = useMemo(() => markdownOptions({ classes }), [classes])

  return (
    <React.Fragment>
      <Markdown options={options}>{sanitizedValue}</Markdown>
    </React.Fragment>
  )
}

PanelFieldPreValue.propTypes = {
  value: PropTypes.string,
}
